import React, { useEffect, useState } from 'react'
import { useTheme } from '../../context/ThemeContext';
import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { ThemeContextType, ThemeTypes } from '../../context/ContextTypes';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';

type IncidentCountCardPropsType = {
    width?: string;
    height?: string;
    backgroundColor?: string;
    gridArea: string;
}

type IncidentReportTypes = {
    active_alevel: string;
    active_pcode: string;
    adm1_en: string;
    adm1_pcode: string;
    adm2_en: string;
    adm2_pcode: string;
    adm3_en: string;
    adm3_pcode: string;
    adm4_en: string;
    adm4_pcode: string;
    bwater_level: string;
    end_time: string;
    hwater_level: string;
    img_url: string;
    imp_communication: string;
    imp_electricity: string;
    imp_house: string;
    imp_human: string;
    imp_response: string;
    imp_roadblock: string;
    imp_roaddamage: string;
    imp_water: string;
    impdes_communication: string;
    impdes_electricity: string;
    impdes_house: string;
    impdes_human: string;
    impdes_roadblock: string;
    impdes_roaddamage: string;
    impdes_water: string;
    issued_time: string;
    lat: number;
    lon: number;
    observed_date: string;
    occurance_date: string;
    severity: string;
    status: string;
    thumbnail: string;
    tp_number: string;
    video_url: string;
    w_desc: string;
    w_id: string;
    w_name: string;
    w_status: string;
    w_type: string;
    water_houses: string;
    water_level: string;
}

const IncidentCountCard = (props: IncidentCountCardPropsType) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const { theme } = useTheme()
    const navigate = useNavigate()

    const [incidentCount, setIncidentCount] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [isNeedReloading, setIsNeedReloading] = useState<boolean>(false)

    const { notifications, unreadCount, removeNotification } = useNotification()

    useEffect(() => {
        if (notifications.length > 0) 
        {
            const latest = notifications[0]
            console.log(`🔔 New: ${latest.title} - ${latest.message}`)
            switch (latest.title)
            {
                case 'NEW_INCIDENT':
                    setIsNeedReloading(prevState => !prevState)
                    break

            }
        }
    }, [notifications])

    useEffect(() => {
        setIsLoading(true)
        const params = new URLSearchParams()
        params.append("arealist", "LK1333")
        params.append("arealist", "LK1312")

        fetch (`${BASE_URL}/hz/api/v1/getHzmByLocationTwoWeek?${params.toString()}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            const response = data as []
            setIncidentCount(response.length)
            //console.log("INCIDENTS -> ", response)
        })
        .catch(error => console.log(error))
        .finally(() => {
            setIsLoading(false)
        })
    }, [isNeedReloading])
    
    return (
        <div className='dashboard-incident-count-card' style={{width: props.width ? props.width : '100%', height: props.height ? props.height : '5rem', backgroundColor: props.backgroundColor ? props.backgroundColor : 'var(--color-side-menu-bg)', gridArea: props.gridArea, border: theme === 'light' ? 'solid 1px gray' : ''}} onClick={(e) => navigate('/incidents/management')}>
            {isLoading ? (
                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} />
                ) : (
                    <span className="count">{incidentCount}</span>
                )
            }
            <span className="name">Incidents</span>
        </div>
    )
}

export default IncidentCountCard